import React from 'react';
import MarkdownText from './MarkdownText';
import ReadingSpeechBubble from './ReadingSpeechBubble';
import './ReadingArticlePractice.css';

export function splitReadingSpeech(text) {
  const lines = String(text || '').replace(/\r\n/g, '\n').split('\n').map(line => line.trim()).filter(Boolean);
  return {
    question: lines[0] || String(text || '').trim(),
    answer: lines.slice(1).join('\n') || lines[0] || String(text || '').trim(),
  };
}

// Shared presentation only: learning rewards and playback stay with each screen.
export default function ReadingContentItem({ item, characterNames, speechText, onSpeechClick, className = '', children }) {
  if (!item?.text) return null;
  if (item.type === 'scene') return (
    <div className="reading-practice-scene-row">
      <span aria-hidden="true" /><MarkdownText text={item.text} /><span aria-hidden="true" />
    </div>
  );
  const position = `${item.segmentIndex}:${item.sentenceIndex || 0}`;
  if (item.type === 'speech') {
    const speaker = item.speaker === 'B' ? 'B' : 'A';
    return (
      <div data-reading-position={position} className={`reading-practice-speech-row speaker-${speaker.toLowerCase()} ${className}`.trim()}>
        <ReadingSpeechBubble name={characterNames?.[speaker] || speaker} speaker={speaker} onClick={onSpeechClick}>
          <MarkdownText text={speechText ?? splitReadingSpeech(item.text).answer} />
        </ReadingSpeechBubble>
        {children}
      </div>
    );
  }
  return <div data-reading-position={position} className={`reading-practice-story-row ${className}`.trim()}>
    <MarkdownText text={item.text} />{children}
  </div>;
}
